/* tslint:disable */
/* eslint-disable */
/**
 * Backend
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    AcademicUser,
    AcademicUserFromJSON,
    AcademicUserFromJSONTyped,
    AcademicUserToJSON,
} from './AcademicUser';
import {
    Subject,
    SubjectFromJSON,
    SubjectFromJSONTyped,
    SubjectToJSON,
} from './Subject';
import {
    SubjectStatusEnum,
    SubjectStatusEnumFromJSON,
    SubjectStatusEnumFromJSONTyped,
    SubjectStatusEnumToJSON,
} from './SubjectStatusEnum';

/**
 * 
 * @export
 * @interface SubjectStatusHistory
 */
export interface SubjectStatusHistory {
    /**
     * 
     * @type {string}
     * @memberof SubjectStatusHistory
     */
    id?: string;
    /**
     * 
     * @type {Date}
     * @memberof SubjectStatusHistory
     */
    createdAt?: Date;
    /**
     * 
     * @type {Date}
     * @memberof SubjectStatusHistory
     */
    updatedAt?: Date;
    /**
     * 
     * @type {string}
     * @memberof SubjectStatusHistory
     */
    subjectId?: string;
    /**
     * 
     * @type {Subject}
     * @memberof SubjectStatusHistory
     */
    subject?: Subject;
    /**
     * 
     * @type {string}
     * @memberof SubjectStatusHistory
     */
    userId?: string;
    /**
     * 
     * @type {AcademicUser}
     * @memberof SubjectStatusHistory
     */
    user?: AcademicUser;
    /**
     * 
     * @type {string}
     * @memberof SubjectStatusHistory
     */
    message?: string | null;
    /**
     * 
     * @type {SubjectStatusEnum}
     * @memberof SubjectStatusHistory
     */
    status?: SubjectStatusEnum;
}

export function SubjectStatusHistoryFromJSON(json: any): SubjectStatusHistory {
    return SubjectStatusHistoryFromJSONTyped(json, false);
}

export function SubjectStatusHistoryFromJSONTyped(json: any, ignoreDiscriminator: boolean): SubjectStatusHistory {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': !exists(json, 'id') ? undefined : json['id'],
        'createdAt': !exists(json, 'createdAt') ? undefined : (new Date(json['createdAt'])),
        'updatedAt': !exists(json, 'updatedAt') ? undefined : (new Date(json['updatedAt'])),
        'subjectId': !exists(json, 'subjectId') ? undefined : json['subjectId'],
        'subject': !exists(json, 'subject') ? undefined : SubjectFromJSON(json['subject']),
        'userId': !exists(json, 'userId') ? undefined : json['userId'],
        'user': !exists(json, 'user') ? undefined : AcademicUserFromJSON(json['user']),
        'message': !exists(json, 'message') ? undefined : json['message'],
        'status': !exists(json, 'status') ? undefined : SubjectStatusEnumFromJSON(json['status']),
    };
}

export function SubjectStatusHistoryToJSON(value?: SubjectStatusHistory | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'createdAt': value.createdAt === undefined ? undefined : (value.createdAt.toISOString()),
        'updatedAt': value.updatedAt === undefined ? undefined : (value.updatedAt.toISOString()),
        'subjectId': value.subjectId,
        'subject': SubjectToJSON(value.subject),
        'userId': value.userId,
        'user': AcademicUserToJSON(value.user),
        'message': value.message,
        'status': SubjectStatusEnumToJSON(value.status),
    };
}

